import { createSlice } from '@reduxjs/toolkit';

export const tiposDocsSlice = createSlice({
    name: "tiposDocsSlice",
    initialState: {
        loadingTiposDocs: false,
        tiposDocs: []
    },
    reducers: {
        loadTiposDocs: (state) => {
            state.loadingTiposDocs = true;
        },
        setTiposDocs: (state, action) => {
            state.loadingTiposDocs = false;
            state.tiposDocs = action.payload.tiposDocs
        }
    }
});

export const { loadTiposDocs, setTiposDocs } = tiposDocsSlice.actions;